import { createAsyncThunk } from "@reduxjs/toolkit";
import { UserDto } from "interfaces/user";
import { userService } from "services/userService";
import { Types } from "store/types/userType";

export const fetchMeAction = createAsyncThunk(
  Types.FETCH_ME,
  async (): Promise<UserDto> => {
    const result = await userService.fetchMe();

    return result.user;
  }
);
